import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import CloseIcon from "@material-ui/icons/Close";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "../Styles/_CancelOrderWindow.css";
import "../Styles/_OrderPopupSimpleWindow.css";
import DataConflictWindow from "./_DataConflictWindow";
let scrolled_into_view = false;

export class CancelOrderWindow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cancelReasonId: null,
            cancelErrorMessage: "",
            cancelFinished: false,
            submitErrors: [],
            dataConflictWindowOpen: false
        };
    }

    componentWillMount() {
        scrolled_into_view = false;
    }

    componentDidMount() {
        this.scrollWindowIntoView();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.loading === false && prevProps.loading === true) {
            if (!this.props.err) {
                this.setState({
                    cancelFinished: true
                });
            } else {
                this.setState({
                    cancelErrorMessage: this.props.currentLanguage.ORDER_PAGE.CANCEL_SECTION.CANCEL_ORDER.ERROR_FAILED
                });
            }
        }

        if (prevProps.open === false && this.props.open === true && this.props.cancelReasons.length === 0 && this.props.cancelReasonsLoading === false) {
            this.props.getCancelReasons();
        }

        if (prevProps.open === false && this.props.open === true) {
            this.resetErrorMessages();
            this.resetCancelReason();
            this.resetCancelFinished();
            this.resetSubmitErrors();
            scrolled_into_view = false;
        }
    }

    scrollWindowIntoView() {
        var element = document.getElementById("cancel-order-window");

        if (element && !scrolled_into_view) {
            element.scrollIntoView({
                behavior: "auto",
                block: "start",
                inline: "center"
            });
            scrolled_into_view = true;

            this.postMessageToParentWindow();
        }
    }

    postMessageToParentWindow() {
        let data = {
            action: "DIALOG_WINDOW_OPEN"
        };

        window.parent.window.postMessage(JSON.stringify(data), "*");
    }

    resetCancelFinished() {
        this.setState({
            cancelFinished: false
        });
    }

    handleNoClick() {
        if (this.state.cancelFinished) {
            this.props.handleClose();
            this.props.getOrder(this.props.order_id);
        } else {
            this.props.handleClose();
        }
    }

    handleYesClick() {
        this.resetSubmitErrors();
        if (this.getSubmitErrors().length === 0) {
            this.props.cancelOrder(this.props.order_id, {
                order: this.props.order,
                reason: this.state.cancelReasonId
            });
        } else {
            this.updateSubmitErrors();
        }
    }

    updateSubmitErrors() {
        this.setState({
            submitErrors: this.getSubmitErrors()
        });
    }

    handleConfirmCancelOrder() {
        this.resetErrorMessages();
        this.cancelOrder();
    }

    cancelOrder() {
        this.props.cancelOrder(this.props.order_id, {
            order: this.props.order,
            items: this.state.cancelItems,
            reason: this.state.cancelReasonId
        });
    }

    getSubmitErrors() {
        let errors = [];

        if (!this.state.cancelReasonId) {
            errors.push({
                code: "cancel_reason",
                label: this.props.currentLanguage.ORDER_PAGE.CANCEL_SECTION.ERRORS.REASON_REQUIRED
            });
        }

        return errors;
    }

    resetSubmitErrors() {
        this.setState({
            submitErrors: []
        });
    }

    resetErrorMessages() {
        this.setState({
            cancelErrorMessage: ""
        });
    }

    handleEnter() {
        this.resetErrorMessages();
    }

    SetBodyScroll() {
        let el = document.getElementById("body");

        if (el.style.overflow === "hidden") {
            el.style.overflow = "initial";
        }
    }

    handleChange(e) {
        switch (e.target.name) {
            case "cancel-reason":
                this.setState({
                    cancelReasonId: e.target.value
                });
                break;

            default:
                break;
        }
    }

    resetCancelReason() {
        this.setState({
            cancelReasonId: null
        });
    }

    handleRefreshOrder() {
        this.props.handleClose();
        this.props.refreshOrder();
    }

    render() {
        const {
            ORDER_PAGE: {
                CANCEL_SECTION: { CANCEL_ORDER, REASON_HEADER, REASONS }
            },
            MISC,
            DATA_CONFLICT
        } = this.props.currentLanguage;

        return (
            <Dialog
                classes={{ paper: `popup-simple-window-dialog-paper${this.state.cancelFinished ? " completed" : ""}` }}
                className="popup-simple-window-dialog"
                disableBackdropClick
                disableEscapeKeyDown
                open={this.props.open || false}
                onEnter={this.handleEnter.bind(this)}
            >
                <div
                    id="popup-simple-window"
                    className={`layout vertical popup-simple-window cancel-order-window relative${this.state.cancelFinished ? " completed" : ""}`}
                >
                    <div className="flex layout horizontal end-justified">
                        <CloseIcon className="layout vertical center-center close-corner-button" onClick={this.handleNoClick.bind(this)} />
                    </div>
                    <div className="flex layout vertical relative">
                        <div className="popup-simple-window-inner">
                            {(this.props.loading || this.props.cancelOrderCalculating || this.props.cancelReasonsLoading) && (
                                <div className={`loading-box fit layout vertical center-center`}>
                                    <CircularProgress className="loading-progress" size={74} color="primary" thickness={6} />
                                </div>
                            )}
                            <div className="layout vertical header">
                                <p className="layout vertical center-center title">{CANCEL_ORDER.HEADING}</p>
                            </div>
                            {!this.state.cancelFinished && (
                                <React.Fragment>
                                    <div className="layout vertical body">
                                        <p className="layout vertical center-center sub-title">{CANCEL_ORDER.SUBHEADING}</p>
                                        {this.props.total_egift_cards !== null && this.props.total_egift_cards > 0 && (
                                            <div className="egiftcards-notice">{CANCEL_ORDER.EGIFTCARDS_PRESENT_MESSAGE}</div>
                                        )}
                                        <div className="cancel-reason-box">
                                            <div className="layout vertical custom-select-box">
                                                <InputLabel className={`custom-select-label`}>{`*${REASON_HEADER}`}</InputLabel>
                                                <Select
                                                    classes={{
                                                        selectMenu: "custom-select-menu"
                                                    }}
                                                    name="cancel-reason"
                                                    MenuProps={{
                                                        variant: "menu",
                                                        getContentAnchorEl: null,
                                                        classes: {
                                                            paper: "custom-select-menu-paper"
                                                        }
                                                    }}
                                                    className="custom-select"
                                                    disabled={false}
                                                    value={this.state.cancelReasonId || -1}
                                                    onChange={this.handleChange.bind(this)}
                                                >
                                                    {this.props.cancelReasons &&
                                                        this.props.cancelReasons.length > 0 &&
                                                        this.props.cancelReasons.map((cancelReason, i) => {
                                                            return (
                                                                <MenuItem key={i} className="form-menu-item-select-multiple" value={cancelReason.id}>
                                                                    <ListItemText
                                                                        classes={{
                                                                            root: "form-menu-item-select-multiple-list-item-text"
                                                                        }}
                                                                    >
                                                                        {REASONS[cancelReason.code]}
                                                                    </ListItemText>
                                                                </MenuItem>
                                                            );
                                                        })}
                                                    )
                                                </Select>
                                            </div>
                                        </div>
                                        {this.state.submitErrors.length > 0 && this.state.submitErrors.find(e => e.code === "cancel_reason") && (
                                            <FormHelperText>{this.state.submitErrors.find(e => e.code === "cancel_reason").label}</FormHelperText>
                                        )}
                                    </div>
                                    <div className="layout vertical footer">
                                        {this.state.cancelErrorMessage && <div className="message-box">{this.state.cancelErrorMessage}</div>}
                                        <div className="layout vertical buttons-box">
                                            <div className="flex layout dynamic-direction-mobile-portrait buttons">
                                                <button className="flex custom-button negative" onClick={this.handleNoClick.bind(this)}>
                                                    <div className="layout vertical center-center inbutton-text">{MISC.CLOSE}</div>
                                                </button>
                                                <button
                                                    className={`flex custom-button ${this.props.loading ? "loading" : ""}`}
                                                    style={{ float: "right" }}
                                                    onClick={this.props.loading ? null : this.handleYesClick.bind(this)}
                                                >
                                                    <div className="layout vertical center-center inbutton-text">{MISC.SUBMIT}</div>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}
                            {this.state.cancelFinished && (
                                <React.Fragment>
                                    <div className="layout vertical body">
                                        <div className="message-box">{CANCEL_ORDER.SUCCESS_MESSAGE}</div>
                                    </div>
                                    <div className="layout vertical footer">
                                        <button className="custom-button" onClick={this.handleNoClick.bind(this)}>
                                            <div className="layout vertical center-center inbutton-text">{MISC.CLOSE}</div>
                                        </button>
                                    </div>
                                </React.Fragment>
                            )}
                            <DataConflictWindow
                                open={this.state.dataConflictWindowOpen}
                                handleSubmit={this.handleRefreshOrder.bind(this)}
                                heading={DATA_CONFLICT.HEADING}
                                subheading={DATA_CONFLICT.SUB_HEADING}
                                yesText={MISC.REFRESH}
                            />
                        </div>
                    </div>
                </div>
            </Dialog>
        );
    }
}

export default withRouter(CancelOrderWindow);
